import React, { useContext, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { resetClusterInfoAction } from 'store/actions/searchTab';
import MapContext from 'components/MapComponent/MapContext';
import 'components/MapComponent/styles.css';
import CloseIcon from '@mui/icons-material/Close';
import Overlay from 'ol/Overlay';
import { Box, IconButton, Typography } from '@mui/material';

export const ClusterModal: React.FC = () => {
  const { clusterInfo } = useAppSelector((state) => state.searchTab);
  const popupContainerRef = useRef<HTMLDivElement | null>(null);
  const { map } = useContext(MapContext);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!map || !clusterInfo.info) return;

    const popupOverlay = new Overlay({
      element: popupContainerRef.current!,
      position: clusterInfo.coordinates,
      autoPan: {
        animation: {
          duration: 250,
        },
      },
    });

    map.addOverlay(popupOverlay);

    return () => {
      map.removeOverlay(popupOverlay);
    };
  }, [map, clusterInfo]);

  return (
    <Box
      sx={{
        display: clusterInfo.info ? 'flex' : 'none',
        flexDirection: 'column',
        backgroundColor: 'white',
        p: 1,
        pt: 0,
        maxWidth: 450,
        minWidth: 400,
        bottom: '20px',
        left: '-46px',
        position: 'absolute',
        borderRadius: '8px',
      }}
      className="ol-popup"
      ref={popupContainerRef}
    >
      {clusterInfo.info ? (
        <>
          <IconButton
            sx={{ alignSelf: 'end' }}
            onClick={() => {
              dispatch(resetClusterInfoAction());
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box>
            <Typography
              dangerouslySetInnerHTML={{ __html: clusterInfo.info }}
            ></Typography>
          </Box>
        </>
      ) : (
        <></>
      )}
    </Box>
  );
};
